import { render } from "./IndexLeft.vue?vue&type=template&id=2b24b380"
import script from "./IndexLeft.vue?vue&type=script&lang=js"
export * from "./IndexLeft.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__